import axios from "axios";
import {
  getToken,
  getRefreshToken,
  setToken,
  setRefreshToken,
} from "../../utils/auth";
import { getUrl, handleRefreshTokensError } from "./requestFunctions";
import store from "../../store/index"
import UserInfoApi from "../../../../Api/UserInfoApi";
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || config.VUE_APP_API_BASE_URL,
  withCredentials: true,
  timeout: 50000,
});

service.interceptors.request.use(
  (config) => {
    if (config.headers["Authorization"])
      return config;
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const err = response.data.errors;
    if (err && Array.isArray(err))
      store.dispatch("errorStore/handleBuisnessErrorError", err);

    return Promise.resolve(response);
  },
  (error) => {
    if (error.response) error.response.success = false;
    let url = getUrl(error);
    if (error.response && error.response.data && error.response.data.errors) {
      store.dispatch("errorStore/handleError", error.response.data);
    } else if (error.response && error.response.status == 401) {
      let refreshToken = getRefreshToken();
      if (!refreshToken) {
        return handleRefreshTokensError(
          error.response,
          "Error on get tokens request: Refresh token is empty"
        );
      } else {
        var bodyFormData = new URLSearchParams();
        bodyFormData.append("grant_type", "refresh_token");
        bodyFormData.append("refresh_token", refreshToken);
        bodyFormData.append("client_id", "jsapp");

        return service
          .request({
            url: `authorization/token`,
            method: "POST",
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((response) => {
            if (!response.data.access_token || !response.data.refresh_token) {
              return handleRefreshTokensError(
                response,
                "Empty tokens. response: " + JSON.stringify(response)
              );
            }
            setToken(response.data.access_token);
            setRefreshToken(response.data.refresh_token);
            let method = error.config.method;
            let body = error.config.data;
            let headers = {
              Accept: error.config.headers["Accept"],
              "Content-Type": error.config.headers["Content-Type"],
            };
            return service
              .request({
                url: url,
                method: method,
                headers: headers,
                data: body,
              })
              .then((ret) => {
                return Promise.resolve(ret);
              })
              .catch((e) => {
                return handleRefreshTokensError(
                  error.response,
                  "Error on repeat request:" + e
                );
              });
          })
          .catch((e) => {
            return handleRefreshTokensError(
              error.response,
              "Error on get tokens request:" + e
            );
          });
      }
    }
    // If role changed claim cache will be updated.
    // Check current role is actual, show modal if is not
    // on accept redirect to home page (current role will be updated in BaseLayout)
    else if (error.response && error.response.status == 403) {
      new UserInfoApi()
        .get()
        .then((res) => {
          if (Object.keys(res.data).length > 0 && res.data.data.role){
            const role = JSON.parse(localStorage.getItem("userRole"));
            if (role.systemName !== res.data.data.role.systemName) {
              store.commit("errorStore/SET_ERROR403_MODAL", true);
              // localStorage.setItem("userRole", JSON.stringify(res.data.data.role));
            } else {
              return Promise.resolve(error.response);
            }
          }
        })
    }
    else {
      return Promise.resolve(error.response);
    }
  }
);

export default service;
